import { Injectable } from '@angular/core';

@Injectable()
export class ErrorDataService {
    errorMessage: string;
    errorJson: any;

    constructor() { }
}
